// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {store} from "./store";
import {Provider} from "react-redux";
import {App as AntdApp} from "antd";
import "antd/dist/reset.css";
import "./css/index.css";
import "./css/adaptive.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AntdApp>
        <App/>
      </AntdApp>
    </Provider>
  </React.StrictMode>
);